import { initializeApp, FirebaseApp } from 'firebase/app';
import { getAuth, Auth, connectAuthEmulator } from 'firebase/auth';
import { getRuntimeConfigValue } from '@mbbe/config';

const firebaseConfig = {
  apiKey: getRuntimeConfigValue('FIREBASE_API_KEY', import.meta.env.VITE_FIREBASE_API_KEY),
  authDomain: getRuntimeConfigValue('FIREBASE_AUTH_DOMAIN', import.meta.env.VITE_FIREBASE_AUTH_DOMAIN),
  projectId: getRuntimeConfigValue('FIREBASE_PROJECT_ID', import.meta.env.VITE_FIREBASE_PROJECT_ID),
  storageBucket: getRuntimeConfigValue(
    'FIREBASE_STORAGE_BUCKET',
    import.meta.env.VITE_FIREBASE_STORAGE_BUCKET
  ),
  messagingSenderId: getRuntimeConfigValue(
    'FIREBASE_MESSAGING_SENDER_ID',
    import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID
  ),
  appId: getRuntimeConfigValue('FIREBASE_APP_ID', import.meta.env.VITE_FIREBASE_APP_ID),
};

function validateFirebaseConfig(config: typeof firebaseConfig): void {
  const required = ['apiKey', 'authDomain', 'projectId', 'appId'] as const;
  const missing = required.filter(key => !config[key]);
  if (missing.length > 0) {
    // Log details for debugging (visible in browser console)
    console.error('[Firebase] Missing configuration keys:', missing);
    // Throw sanitized error for UI display
    throw new Error(
      'Application configuration error. Please contact support or check build configuration.'
    );
  }
}

let app: FirebaseApp;
let auth: Auth;

export function initializeFirebase(): FirebaseApp {
  validateFirebaseConfig(firebaseConfig);
  if (!app) {
    app = initializeApp(firebaseConfig);
    auth = getAuth(app);

    if (import.meta.env.DEV && import.meta.env.VITE_USE_FIREBASE_EMULATORS === 'true') {
      connectAuthEmulator(auth, import.meta.env.VITE_FIREBASE_AUTH_EMULATOR_URL || 'http://127.0.0.1:9099');
    }
  }
  return app;
}

export function getAuthInstance(): Auth {
  if (!auth) initializeFirebase();
  return auth;
}
